<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="pb-12">
          <setup-job-position-container-view />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupJobPositionContainerView: () => import('@/components/hris/setup/job-position/ContainerView'),
    },
    metaInfo () {
      return {
        title: 'Setup Job Position',
      }
    },
  }
</script>
